import { render, staticRenderFns } from "./PriceCardBox.vue?vue&type=template&id=b612d5fa"
import script from "./PriceCardBox.vue?vue&type=script&lang=js"
export * from "./PriceCardBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StockPriceIcon: require('/vercel/path0/components/ui/StockPriceIcon.vue').default})
